<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'assign-inventory'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Assign Inventory</span><span v-if="privilegeDetail.name"> : </span>{{ privilegeDetail.name }}
      </div>
    </template>
    <b-row>
      <b-col
        cols="12"
        class="px-2"
      >
        <search :on-search-input="onSetValueSearch" />
      </b-col>
      <b-col
        cols="12"
        class="px-2 mt-2"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="inventoryList.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="assign-inventory-table"
            >
              <template #cell(actions)="data">
                <add-button
                  :btn-label="'Assign'"
                  :is-disabled="resolveAssignInventory(data.item)"
                  @click.native="onAssignInventory(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <b-row class="modal-body-container mb-1" />
  </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import Search from '@/views/components/search/Search.vue'
import AddButton from '@/views/components/button/AddButton.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useAssignInventoryModal from '../hooks/useAssignInventoryModal'

export default {
  components: {
    BaseModal,
    Search,
    AddButton,
    PaginationWithReorder,
  },
  props: {
    privilegeObj: {
      type: Object,
      default: {},
    },
  },
  setup(props) {
    const {
      inventoryList,
      onModalOpen,
      fields,
      loading,
      pagination,
      onPageChange,
      onSetValueSearch,
      privilegeDetail,
      resolveAssignInventory,
      onAssignInventory,
    } = useAssignInventoryModal(props)
    return {
      inventoryList,
      onModalOpen,
      fields,
      loading,
      pagination,
      onPageChange,
      onSetValueSearch,
      privilegeDetail,
      resolveAssignInventory,
      onAssignInventory,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/assign-inventory.css';
</style>
